import React from "react";
import { PopupHint } from "@op/opds.opux";
import { prettyPrintPhoneNumber, validatePhoneNumber } from "@op/opds.validate";
import { Message, useMessageGetter } from "react-message-context";
import { inject, observer } from "mobx-react";
import withAnimation from "../../../utils/withAnimation";
import { TEL } from "../../../utils/enums";
import {
  emptyError,
  invalidTextFieldError,
  isBlank,
  useUpdateIncluded,
} from "../../../utils/commonUtils";
import TextField from "./TextField";

const ContactPhone = observer(({ FeedbackStore, mount }) => {
  const key = "phone";
  const { feedback, updateError, updateValue, updateIncluded, contactByPhone } =
    FeedbackStore;
  const phone = feedback.phone;
  const msgs = useMessageGetter("feedback.form.phone");
  const moreInfo = useMessageGetter("feedback.form.moreInformation");
  const popupHintLabel = `${moreInfo("label")}: ${msgs("label")}`;
  // Update included property when contactByPhone value changes
  useUpdateIncluded(key, contactByPhone, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (isBlank(phone.value)) {
      updateError(key, emptyError(msgs));
    } else {
      const result = validatePhoneNumber(phone.value);
      updateError(key, !!result.code ? invalidTextFieldError(msgs) : false);
    }
  };

  if (!contactByPhone && mount === undefined) return null;

  return (
    <TextField
      fieldName={key}
      type={TEL}
      autocomplete={TEL}
      value={prettyPrintPhoneNumber(phone.value)}
      error={phone.error}
      handleOnChange={handleOnChange}
      handleOnBlur={handleOnBlur}
      hint={
        <PopupHint label={popupHintLabel}>
          <Message id="feedback.form.phone.hint" />
        </PopupHint>
      }
      maxLength={50}
    />
  );
});

export default withAnimation(inject("FeedbackStore")(ContactPhone));
export const ContactPhoneNoAnimation = inject("FeedbackStore")(ContactPhone);
